import React, { createContext, useReducer, useCallback } from "react"

export const AppContext = createContext()

// Action types
export const ACTIONS = {
  // User actions
  LOGIN_USER: "LOGIN_USER",
  LOGOUT_USER: "LOGOUT_USER",

  // Global actions
  SET_LOADING: "SET_LOADING",

  // Menu actions
  TOGGLE_MENU: "TOGGLE_MENU",
  SET_MENU_OPEN: "SET_MENU_OPEN",
  SET_MENU_CLOSED: "SET_MENU_CLOSED",
}

// Initial state
const initialState = {
  user: (() => {
    try {
      return JSON.parse(localStorage.getItem("userRealState")) || null
    } catch {
      return null
    }
  })(),
  isLoading: false,
  menuOpen: false,
}

// Reducer
const appReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.LOGIN_USER:
      localStorage.setItem("userRealState", JSON.stringify(action.payload))
      return {
        ...state,
        user: action.payload,
      }

    case ACTIONS.LOGOUT_USER:
      localStorage.removeItem("userRealState")
      return {
        ...state,
        user: null,
      }

    case ACTIONS.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }

    case ACTIONS.TOGGLE_MENU:
      return {
        ...state,
        menuOpen: !state.menuOpen,
      }

    case ACTIONS.SET_MENU_OPEN:
      return {
        ...state,
        menuOpen: true,
      }

    case ACTIONS.SET_MENU_CLOSED:
      return {
        ...state,
        menuOpen: false,
      }

    default:
      return state
  }
}

// Provider component
export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState)

  // Action creators
  const loginUser = useCallback((userData) => {
    dispatch({
      type: ACTIONS.LOGIN_USER,
      payload: userData,
    })
  }, [])

  const logoutUser = useCallback(() => {
    dispatch({
      type: ACTIONS.LOGOUT_USER,
    })
  }, [])

  const setLoading = useCallback((isLoading) => {
    dispatch({
      type: ACTIONS.SET_LOADING,
      payload: isLoading,
    })
  }, [])

  const toggleMenu = useCallback(() => {
    dispatch({
      type: ACTIONS.TOGGLE_MENU,
    })
  }, [])

  const setMenuOpen = useCallback(() => {
    dispatch({
      type: ACTIONS.SET_MENU_OPEN,
    })
  }, [])

  const setMenuClosed = useCallback(() => {
    dispatch({
      type: ACTIONS.SET_MENU_CLOSED,
    })
  }, [])

  const value = {
    // State
    state,
    user: state.user,
    isLoading: state.isLoading,
    menuOpen: state.menuOpen,

    // Actions
    loginUser,
    logoutUser,
    setLoading,
    toggleMenu,
    setMenuOpen,
    setMenuClosed,
    dispatch,
  }

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export default AppContext
